import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InspectionsJanusServiceData } from './inspections-janus.model';

@Injectable({ providedIn: 'root' })
export class InspectionsJanusService {
  private dataSource = new BehaviorSubject<InspectionsJanusServiceData>({
    searchText: [],
    filterInputs: [],
    attributeFilterInputs: [],
    reRunInspectionsTable: false,
    columns: [],
    columnOptions: [],
    exportOptions: [],
    isEditorVisible: false,
  });

  data$ = this.dataSource.asObservable();

  setData(data: InspectionsJanusServiceData): void {
    this.dataSource.next(data);
  }

  getData(): InspectionsJanusServiceData {
    return this.dataSource.value;
  }
}
